// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__1xldP","title":"Modal_title__3wrnG","text":"Modal_text__23DNO","buttonsContainer":"Modal_buttonsContainer__26r-u","button":"Modal_button__3qiHs"};